// Base URL de l'API, configurable via REACT_APP_API_URL (dev local).
// Defaut = backend de prod, donc aucun impact sur le build de prod.
export const API_BASE =
  process.env.REACT_APP_API_URL || 'https://api.zeiterfassung.dantz-ip.com';

export const apiUrl = (path: string) =>
  `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`;
